import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";
import { CommonProjectDataService } from "../../_services/common-project-data.service";

export interface DialogData {
  invoiceId: string;
  clientId: string;
  addressType: string;

}

@Component({
  selector: 'app-update-invoice-address',
  templateUrl: './update-invoice-address.component.html',
  styleUrls: ['./update-invoice-address.component.css']
})
export class UpdateInvoiceAddressComponent implements OnInit {
  clientAddressForm: FormGroup;
  public clientOptions: any = {};
  public clientAddress: Array<any> = [];
  public result = "";
  public addressId: '';
  public isFormShow = false;
  public loading = false;
  public countryList: Array<any> = [];
  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<UpdateInvoiceAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
    private _flashMessagesService: FlashMessagesService) {
    this.clientAddressForm = this.fb.group({
      name: [null],
      email: [null, Validators.email],
      phone: [null],
      address1: [null, Validators.required],
      address2: [null],
      city: [null, Validators.required],
      state: [null, Validators.required],
      zip: [null, Validators.required],
      country: [null, Validators.required]
    })

  }

  ngOnInit() {
    this.countryList = this.CommonProjectDataService.getCountryList();
    this.getUserAddressData();
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  getUserAddressData = function () {
    this.loading=true;
    this.clientOptions = {
      id: this.data.clientId
    };

    this.CommonService.apiService(
      "POST",
      "user/addresses",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        this.loading=false;
        if (response.status === true) {
          if (response.data) {
            this.clientAddress = response.data;
          }
        }
      },
      err => {
        this.loading=false;
        console.log(err);
      }
    );
  }

  updateInvoiceAddress = function () {    
    if (this.addressId != '') {
      this.loading=true;
      this.clientOptions = {
        id: localStorage.getItem("userID"),
        invoice_id: this.data.invoiceId,
        address_id: this.addressId,
        type: this.data.addressType
      };

      this.CommonService.apiService(
        "POST",
        "invoice/address/edit",
        this.clientOptions
      ).subscribe(
        (response: any) => {
          this.loading=false;
          if (response.status === true) {
            this.addressId = '';
            this.dialogRef.close("success");

          }
        },
        err => {
          this.loading=false;
          console.log(err);
        }
      );
    }
    else {
      this._flashMessagesService.show("Please Select Address", {
        cssClass: "alert-warning",
        timeout: 3000
      });
    }
  }

  selectAddress(address) {
    if (address != '') {
      this.addressId = address
    }
    else {
      this.addressId = '';
      this._flashMessagesService.show("Please Select Address", {
        cssClass: "alert-warning",
        timeout: 3000
      });
    }

  }

  saveAddressFormData = function (postData) {

    if (this.clientAddressForm.valid) {
      this.loading=true;
      var formData = new FormData();
      formData.append('name', postData.name);
      formData.append('address1', postData.address1);
      formData.append('address2', postData.address2);
      formData.append('city', postData.city);
      formData.append('state', postData.state);
      formData.append('zip', postData.zip);
      formData.append('country', postData.country);
      formData.append('phone', postData.phone);
      formData.append('email', postData.email);
      formData.append('id', this.data.clientId);

      this.CommonService.apiService(
        "POST",
        "user/address/create",
        formData
      ).subscribe(
        (response: any) => {
          this.loading=false;
          if (response.status === true) {
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 2000
            });
            this.getUserAddressData();
            this.isFormShow = false;

          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading=false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 3000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.clientAddressForm);
    }
  };

  isFieldValid(field: string) {
    return (
      !this.clientAddressForm.get(field).valid &&
      this.clientAddressForm.get(field).touched
    );
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  showAddAddressForm() {
    this.isFormShow = true;
  }

  cancelFrom() {
    this.isFormShow = false;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/update-invoice-address/update-invoice-address.component.ts